import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import Bg from '@/assets/images/background.png'
import { HeaderAuth } from '@/pages/auth/components/header-auth'
import { authQuery, defaultAuthQuery } from '@/pages/auth/search-schema'
import { store } from '@/store'
import { getBackUrl } from '@/utils/helpers'

export const Route = createFileRoute('/_auth')({
  component: LayoutComponent,
  validateSearch: (search) => authQuery.catch(defaultAuthQuery).parse(search),
  loaderDeps: ({ search }) => {
    return {
      search,
    }
  },
  loader: async ({ deps: { search }, location }) => {
    const state = store.getState()

    if (!state.isInitialized) {
      await state.initialize()
    }

    const isOnTermsPage = location.pathname === '/login/oauth/start'
    const isInNewUserFlow = sessionStorage.getItem('new_user_flow') === 'true'

    if (store.getState().isAuthorized && !isOnTermsPage && !isInNewUserFlow) {
      throw redirect({
        to: getBackUrl(search.back_url),
        replace: true,
      })
    }

    if (isOnTermsPage && state.isAuthorized && state.termsAccepted) {
      throw redirect({
        to: getBackUrl(search.back_url),
        replace: true,
      })
    }
  },
})

function LayoutComponent() {
  return (
    <div
      className="min-h-[100dvh] bg-background-default bg-right-bottom bg-no-repeat [background-size:contain] sm:[background-image:none]"
      style={{ backgroundImage: `url(${Bg})` }}
    >
      <div className="mx-auto w-full max-w-[1280px] px-6 pt-[36px] sm:px-4 sm:pt-4">
        <HeaderAuth />
        <div className="py-10">
          <Outlet />
        </div>
      </div>
    </div>
  )
}
